import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { SYSTEM_ICON_BASE_CLASSNAME } from './Constants';
import { createSystemIcon } from './SystemIcon';
createComponents(".".concat(SYSTEM_ICON_BASE_CLASSNAME), createSystemIcon, NO_PATTERN_BUSINESS_LOGIC);
